// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {Hidden, Grid} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';

import type {Node} from 'react';

type Props = {|
  children: Node,
|};

const useStyles = makeStyles(theme => ({
  floatingBottomWrapper: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: 'fit-content',
    background: '#FFFFFF',
    boxShadow:
      '0px 1px 6px rgba(157, 157, 157, 0.25), 0px -8px 16px rgba(150, 150, 150, 0.12)',
    borderRadius: '20px 20px 0px 0px',
    zIndex: 100,
  },
}));

export default function FloatingBottom(props: Props) {
  const classes = useStyles();

  return (
    <div className={classes.floatingBottomWrapper}>
      <Hidden mdUp>
        <Grid container justify="center">
          <Grid item xs={12} sm={10} md={8}>
            {props.children}
          </Grid>
        </Grid>
      </Hidden>
    </div>
  );
}

FloatingBottom.propTypes = {
  children: PropTypes.node.isRequired,
};
